module.exports = __webpack_public_path__ + "img/vender.62ae4e15.png";